// p5Docs.js - version-aware router for p5.js documentation
// - Maps a p5Version (e.g. '2.1.1') to a docs/signatures dataset
// - Merges official generated 2.1.1 docs (554 functions) with hand-written overrides
// - Hand-written signatures have better parameter info for common functions with overloads
import p5Docs211Raw from '../../public/p5-docs/2.1.1.json'
import { p5Signatures } from './p5Signatures'

// Merge: Start with generated docs (554 functions), override with hand-written ones
// that have better parameter info (line, rect, ellipse, background, etc.)
const p5Docs211Merged = {
  ...p5Docs211Raw,
  ...p5Signatures  // Hand-written overrides for ~20 common functions
}

// Use merged docs for all versions (p5 API is largely backwards compatible)
const docsByVersion = {
  '1.6.0': p5Docs211Merged,
  '1.9.0': p5Docs211Merged,
  '1.10.0': p5Docs211Merged,
  '2.1.1': p5Docs211Merged,
}

export function getP5Signatures(version = '2.1.1') {
  return docsByVersion[version] || docsByVersion['2.1.1']
}

export function getP5FunctionNames(version = '2.1.1') {
  const signatures = getP5Signatures(version)
  return Object.keys(signatures)
}
